// js/accounts/session.js
// Tiny facade that tells the rest of the app which auth backend (if any)
// is currently active. The Nostr stack is loaded lazily — `getNostrAuth`
// is set by app.js at bootstrap time once the dynamic import resolves.

import { authManager as appwriteAuth } from './auth.js';
import { LAST_ACTIVE_SESSION_KEY } from './nostr/config.js';

let _getNostrAuth = null;

export function registerNostrAuthAccessor(fn) {
    _getNostrAuth = fn;
}

const nostrUser = () => {
    try {
        return _getNostrAuth ? _getNostrAuth()?.user ?? null : null;
    } catch {
        return null;
    }
};

export function currentSession() {
    const nUser = nostrUser();
    if (nUser) {
        return {
            kind: 'nostr',
            id: nUser.pubkey,
            displayName: nUser.displayName,
            npub: nUser.npub,
            accountType: nUser.accountType,
            isReadonly: !!nUser.isReadonly,
        };
    }
    if (appwriteAuth?.user) {
        return {
            kind: 'appwrite',
            id: appwriteAuth.user.$id,
            displayName: appwriteAuth.user.email ?? '',
            isReadonly: false,
        };
    }
    return { kind: 'none', id: null, displayName: '', isReadonly: false };
}

export function lastActiveSessionMarker() {
    try {
        return localStorage.getItem(LAST_ACTIVE_SESSION_KEY);
    } catch {
        return null;
    }
}

export function setLastActiveSessionMarker(value) {
    try {
        if (value) localStorage.setItem(LAST_ACTIVE_SESSION_KEY, value);
        else localStorage.removeItem(LAST_ACTIVE_SESSION_KEY);
    } catch {
        // ignore
    }
}
